import { render, staticRenderFns } from "./VolunteerJob.vue?vue&type=template&id=6c552dfe&"
import script from "./VolunteerJob.vue?vue&type=script&lang=js&"
export * from "./VolunteerJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports